import React, { FC, useState } from 'react'
import {
    Typography,
    makeStyles,
    createStyles
} from '@material-ui/core'

import { PaymentMethodItem } from '../../../components/PaymentMethodItem'
import { PaymentMethodStoreConfiguration } from './PaymentMethodStoreConfiguration'
import { PaymentMethodStoreDto } from '../entities/PaymentMethodStoreDto'
import { PaymentMethodData } from '../entities/PaymentMethodData'

interface Props {
    storeCode: string
    paymentMethodsStore?: PaymentMethodStoreDto[]
    onReset: () => void
}

const paymentMethods = [
    {
        code: 'PO',
        name: 'Pago en caja',
    },
    {
        code: 'MP',
        name: 'Mercado pago',
    },
    {
        code: 'ML',
        name: 'Mercado pago link',
    },
    {
        code: 'FP',
        name: 'FPay'
    }
]

export const PaymentMethodStore: FC<Props> = ({
    storeCode,
    paymentMethodsStore = [],
    onReset
}) => {
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<PaymentMethodData>()

    const styles = useStyles()

    const data: PaymentMethodData[] = paymentMethods.map(paymentMethod => {
        const paymentMethodFound = paymentMethodsStore.find(p => p.paymentMethodCode === paymentMethod.code)

        const info = !paymentMethodFound
                     ? 'Sin configurar'
                     : paymentMethodFound.active
                        ? 'Activado'
                        : 'Desactivado'

        return {
            ...paymentMethod,
            info,
            paymentMethod: paymentMethodFound
        }
    })

    const handleModalClose = (success?: boolean) => {
        if(success) {
            onReset()
        }

        setSelectedPaymentMethod(undefined)
    }

    return (
        <div>
            <Typography variant='h5' component='h2'>Medios de pago asociados</Typography>

            <div className={`${styles.content}`}>
                {
                    data.map((item) => 
                        <PaymentMethodItem
                            key={item.code}
                            title={item.name}
                            info={item.info}
                            buttonText='Configurar'
                            buttonAction={() => setSelectedPaymentMethod(item)}
                        />
                    )
                }
            </div>
            {
                selectedPaymentMethod &&
                <PaymentMethodStoreConfiguration
                    open={!!selectedPaymentMethod}
                    storeCode={storeCode}
                    onClose={handleModalClose} 
                    paymentMethodStoreData={selectedPaymentMethod} 
                />
            }
        </div>
    )
}

const useStyles = makeStyles(
    createStyles({
        row: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        content: {
            marginTop: 20,
        },
        titleContainer: {
            flex: 1,
        },
        actionContainer: {
            flex: 0.25,
            display: 'flex',
            justifyContent: 'space-between'
        }
    })
)

